import { Table } from '@vwfs-bronson/bronson-react';
import { Skill } from '../fes';

export function SkillsTable({ skills }: { skills: Skill[] }) {
  if (skills.length === 0) {
    return <p className="app-empty">No skills found.</p>;
  }

  return (
    <div className="app-table-wrap">
      <Table className="app-table" colored>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Description</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {skills.map(skill => (
            <Table.Tr key={skill.skillId || skill.name}>
              <Table.Td>{skill.name}</Table.Td>
              <Table.Td>{skill.description || '-'}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
